var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"checkbox",class:{ 'checked': _vm.checked }},[_c('i',{staticClass:"iconfont icongou"})])}
var staticRenderFns = []

export { render, staticRenderFns }